import { render, staticRenderFns } from "./savehome.vue?vue&type=template&id=d0c99158"
import script from "./savehome.vue?vue&type=script&lang=js"
export * from "./savehome.vue?vue&type=script&lang=js"
import style0 from "./savehome.vue?vue&type=style&index=0&id=d0c99158&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports